import {Injectable} from '@angular/core';

@Injectable()
export class SortService {

    constructor() {
    }

    public parseSort(filterParams: any): {sortField: string, sortOrder: number} {
        const result = {
            sortField: '',
            sortOrder: 0
        };

        if (filterParams.hasOwnProperty('SORT_COLUMN')) {
            result.sortField = filterParams['SORT_COLUMN'];
        }

        if (filterParams.hasOwnProperty('SORT_DIRECTION')) {
            if (filterParams['SORT_DIRECTION'] === 'ASC') {
                result.sortOrder = 1;
            } else if (filterParams['SORT_DIRECTION'] === 'DESC') {
                result.sortOrder = -1;
            } else {
                result.sortOrder = 0;
            }
        }

        return result;
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/oes/services/sort.service.ts